// Filename: uicanvasstageseqaction.js
// Timestamp: 2017.11.19-13:42:37 (last modified)
// Author(s): bumblehead <chris@bumblehead.com>

const setstagecanvaselemcursor = (stagecfg, cursorstyle) => {
  const canvaselem = stagecfg.glcanvaselem

  if (canvaselem)
    canvaselem.style.cursor = cursorstyle
}

export default {
  type: 'uicanvasstageseqaction',
  setstagecanvaselemcursor
}
